import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../services/authService';

const PrivateRoute = ({ element: Component, requiredCodes, ...rest }) => {
  const isAuthenticated = AuthService.estConnecte();
  const userCode = AuthService.getCode()?.toLowerCase();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requiredCodes && !requiredCodes.map(code => code.toLowerCase()).includes(userCode)) {
    return <Navigate to="/" />;
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
